import { composeConfigs, PreviewWeb, ClientApi } from '@storybook/preview-api';
  import '/virtual:/@storybook/builder-vite/setup-addons.js';
  import { importFn } from '/virtual:/@storybook/builder-vite/storybook-stories.js';
  
    
  const getProjectAnnotations = async () => {
    const configs = await Promise.all([import('@storybook/react/preview'),
import('@storybook/addon-links/preview'),
import('@storybook/addon-essentials/docs/preview'),
import('@storybook/addon-essentials/actions/preview'),
import('@storybook/addon-essentials/backgrounds/preview'),
import('@storybook/addon-essentials/measure/preview'),
import('@storybook/addon-essentials/outline/preview'),
import('@storybook/addon-essentials/highlight/preview'),
import('@storybook/addon-interactions/preview'),
import('/.storybook/preview.ts')])
    return composeConfigs(configs);
  }

    window.__STORYBOOK_PREVIEW__ = window.__STORYBOOK_PREVIEW__ || new PreviewWeb();
    
    window.__STORYBOOK_STORY_STORE__ = window.__STORYBOOK_STORY_STORE__ || window.__STORYBOOK_PREVIEW__.storyStore;
    window.__STORYBOOK_CLIENT_API__ = window.__STORYBOOK_CLIENT_API__ || new ClientApi({ storyStore: window.__STORYBOOK_PREVIEW__.storyStore });
    window.__STORYBOOK_PREVIEW__.initialize({ importFn, getProjectAnnotations });
    
    if (import.meta.hot) {
      import.meta.hot.accept('/virtual:/@storybook/builder-vite/storybook-stories.js', (newModule) => {
      // importFn has changed so we need to patch the new one in
      window.__STORYBOOK_PREVIEW__.onStoriesChanged({ importFn: newModule.importFn });
      });

    import.meta.hot.accept(["@storybook/react/preview","@storybook/addon-links/preview","@storybook/addon-essentials/docs/preview","@storybook/addon-essentials/actions/preview","@storybook/addon-essentials/backgrounds/preview","@storybook/addon-essentials/measure/preview","@storybook/addon-essentials/outline/preview","@storybook/addon-essentials/highlight/preview","@storybook/addon-interactions/preview","/.storybook/preview.ts"], () => {
      
  const getProjectAnnotations = async () => {
    const configs = await Promise.all([import('@storybook/react/preview'),
import('@storybook/addon-links/preview'),
import('@storybook/addon-essentials/docs/preview'),
import('@storybook/addon-essentials/actions/preview'),
import('@storybook/addon-essentials/backgrounds/preview'),
import('@storybook/addon-essentials/measure/preview'),
import('@storybook/addon-essentials/outline/preview'),
import('@storybook/addon-essentials/highlight/preview'),
import('@storybook/addon-interactions/preview'),
import('/.storybook/preview.ts')])
    return composeConfigs(configs);
  }
      // getProjectAnnotations has changed so we need to patch the new one in
      window.__STORYBOOK_PREVIEW__.onGetProjectAnnotationsChanged({ getProjectAnnotations });
    });
  };